import React from 'react';
import { useTranslation } from 'react-i18next';

function ProgressIndicator({ currentPage, totalPages }) {
  const { t } = useTranslation();
  const percentage = (currentPage / totalPages) * 100;

  return (
    <div className="w-full">
      <div className="flex justify-between items-center mb-2">
        <span className="text-sm font-medium text-gray-700">
          {t('progress.page')} {currentPage} {t('progress.of')} {totalPages}
        </span>
        <span className="text-sm font-medium text-gray-700">
          {Math.round(percentage)}% {t('progress.complete')}
        </span>
      </div>
      <div className="w-full bg-gray-200 rounded-full h-2">
        <div 
          className="bg-gradient-to-r from-blue-500 to-blue-600 h-2 rounded-full transition-all duration-300 ease-in-out progress-bar"
          style={{ width: `${percentage}%` }}
        ></div>
      </div>
    </div>
  );
}

export default ProgressIndicator;
